import React from 'react';

import { REJECT_APPROVAL_CHAIN_STEP_MUTATION } from '@approvals/graphql';
import { RejectionDrawer, RejectionDrawerValues } from '@common/components';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';

export const ApprovalChainsRejectDrawer = ({
  approvalChainStepId,
  worksMembershipId,
  rejectionDrawerTitle,
  open,
  onClose,
}: {
  approvalChainStepId?: string | null;
  worksMembershipId?: string | null;
  rejectionDrawerTitle?: string | null;
  open: boolean;
  onClose: () => void;
}) => {
  const [rejectStep, { loading: rejectingLoading }] = useMutation(
    REJECT_APPROVAL_CHAIN_STEP_MUTATION,
    {
      onCompleted() {
        createMessage('success', 'This approval request has been rejected.');
        onClose();
      },
      onError: () => {
        createMessage(
          'error',
          'Approval Chain Step could not be rejected. Please try again or contact your hiring partner.'
        );
      },
      refetchQueries: [
        'StaffingRequestPageQuery',
        'CandidateAssignmentQuery',
        'ApprovalChainsPendingActionListQuery',
      ],
    }
  );

  const onRejectClick = (input: RejectionDrawerValues) => {
    if (!approvalChainStepId || !worksMembershipId) return;

    rejectStep({
      variables: {
        input: {
          approvalChainStepId,
          worksMembershipId,
          ...input,
        },
      },
    });
  };

  return (
    <RejectionDrawer
      loading={rejectingLoading}
      onClose={onClose}
      onRejectClick={onRejectClick}
      title={rejectionDrawerTitle || 'Rejection Reason'}
      visible={open}
      reasonsListQuery="ApprovalChainRejectionReasons"
    />
  );
};
